export default "__VITE_ASSET__4eba74aa__"